import React, { Component } from 'react';
import { Icon } from './../../component/icon';

import './headerPanel.css';

class HeaderPanel extends Component {
  render() {
    const { feed } = this.props;
    return (
      <div id="header-panel">
        <div className="container flex-row inner">
          <div className="icons-container flex-row ">
            <a
              href="https://www.kosiceonline.sk"
              target={
                process.env.REACT_APP_BASE_URL !== 'https://www.kosiceonline.sk'
                  ? '_blank'
                  : ''
              }
            >
              <Icon
                name={
                  process.env.REACT_APP_BASE_URL ===
                  'https://www.kosiceonline.sk'
                    ? 'kosiceonline'
                    : 'kosiceonlineInactive'
                }
                className="header-panel-icon"
              />
            </a>
            <a
              href="https://www.radiokosice.sk"
              target={
                process.env.REACT_APP_BASE_URL !== 'https://www.radiokosice.sk'
                  ? '_blank'
                  : ''
              }
              rel="noopener noreferrer"
            >
              <Icon
                name={
                  process.env.REACT_APP_BASE_URL ===
                  'https://www.radiokosice.sk'
                    ? 'radiokosice'
                    : 'radiokosiceInactive'
                }
                className="header-panel-icon"
              />
            </a>
            <a href="https://www.tvkosice.sk" target="_blank" rel="noopener noreferrer">
              <Icon name="tvkosice" className="header-panel-icon" />
            </a>
            <a
              href="http://www.kosicenightrun.sk/"
              target="_blank"
              className="side-icon-link"
              id="nightRunIconLink"
              rel="noopener noreferrer"
            >
              <Icon name="nightRunInactive" className="header-panel-icon" />
            </a>
            <a
              href="http://www.runwayrun.sk/"
              target="_blank"
              className="side-icon-link"
              id="runwayRunIconLink"
              rel="noopener noreferrer"
            >
              <Icon name="runwayRunInactive" className="header-panel-icon" />
            </a>
            <a
              href=""
              target=""
              className="side-icon-link"
              id="h20MineralIconLink"
            >
              <Icon name="h2oMineralInactive" className="header-panel-icon" />
            </a>
          </div>
          {feed === null ? (
            <div />
          ) : (
            <div className="feeds-container">
              <a href={feed.url} target="_blank">
                <div className="flex-row feed-content-container">
                  <div
                    className="image-container"
                    style={{ backgroundImage: `url(${feed.picture})` }}
                  />
                  <div className="flex-row">
                    <b>Aktuálne:</b>
                    <span className="feed-content">{feed.title}</span>
                  </div>
                </div>
              </a>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default HeaderPanel;



// WEBPACK FOOTER //
// ./src/ui/src/component/headerPanel/index.js